import {inject} from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import { SubscriptionsActions } from "./subscriptions.actions";
import {SubscriptionRepo} from "../../repositories/subscription-repo";

export class SubscriptionsEffect {
  private readonly actions$ = inject(Actions);
  private readonly apiService = inject(SubscriptionRepo);

  search$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(SubscriptionsActions.search),
      mergeMap((param) => {
        return this.apiService.getSubscriptionList(param.filter.offset || 0, param.filter.limit, [], '')
        .pipe(
          map(response => SubscriptionsActions.fetchSuccess({ response:  response.list || []})),
          catchError(error => of(SubscriptionsActions.fetchFailure({message: error?.toString()})))
        )
      }),
    );
  });
}
